import { Link } from 'react-router-dom'
import SiteLayout from '@/components/feature/SiteLayout'
import MovieCard from '@/components/feature/MovieCard'
import SectionHeading from '@/components/feature/SectionHeading'
import { usePageSeo } from '@/hooks/usePageSeo'
import { movies } from '@/mocks/movies'
import HeroCarousel from './components/HeroCarousel'
import CategoryShortcuts from './components/CategoryShortcuts'
import HotRanking from './components/HotRanking'

const HOME_TITLE = '麻豆传媒在线 - 最新影视作品在线观看平台'
const HOME_DESCRIPTION =
  '麻豆传媒在线网站提供丰富的麻豆传媒影视作品内容，覆盖电影、电视剧等多个类别，满足用户在线观看和影视资讯需求。'
const HOME_KEYWORDS =
  '麻豆传媒在线,麻豆传媒,电影在线观看,在线影视,影视平台,高清影视,影视作品,影视观看'

export default function Home() {
  usePageSeo(HOME_TITLE, HOME_DESCRIPTION, HOME_KEYWORDS)

  const featured = movies.filter((movie) => movie.featured)
  const latest = [...movies]
    .sort((a, b) => b.year - a.year || a.hot - b.hot)
    .slice(0, 8)
  const hot = [...movies].sort((a, b) => a.hot - b.hot).slice(0, 8)

  return (
    <SiteLayout>
      <h1 className="sr-only">麻豆传媒在线 - 最新影视作品在线观看平台</h1>

      <div className="page-shell pt-5 md:pt-6">
        <HeroCarousel slides={featured} />
        <CategoryShortcuts />
      </div>

      <section className="page-shell mt-12" aria-labelledby="latest-title">
        <div id="latest-title">
          <SectionHeading
            eyebrow="NEW ARRIVALS"
            title="最新上线"
            description="按上线年份整理的新近作品，封面与详情页信息保持一致。"
            actionLabel="查看全部分类"
            actionTo="/category?sort=latest"
          />
        </div>
        <div className="grid grid-cols-2 gap-x-3 gap-y-6 sm:grid-cols-3 md:gap-x-4 lg:grid-cols-4">
          {latest.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </section>

      <section className="mt-14 bg-background-100 py-12" aria-labelledby="hot-title">
        <div className="page-shell">
          <div id="hot-title">
            <SectionHeading
              eyebrow="TRENDING NOW"
              title="热门推荐"
              description="根据站内关注度排序，点击任意一行即可进入作品详情。"
              actionLabel="进入分类页筛选"
              actionTo="/category?sort=hot"
            />
          </div>
          <HotRanking list={hot} />
        </div>
      </section>

      <section className="page-shell mt-14" aria-labelledby="intro-title">
        <div className="grid grid-cols-1 gap-8 rounded-xl border border-background-200 bg-background-50 p-6 md:p-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-7">
            <p className="flex items-center gap-2 text-[11px] tracking-wide text-accent-700">
              <span className="h-1 w-1 rounded-full bg-accent-500" />
              ABOUT THE SITE
            </p>
            <h2
              id="intro-title"
              className="mt-2 text-xl font-bold tracking-tight text-foreground-950 md:text-2xl"
            >
              一个专注于影视作品浏览的在线门户
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              麻豆传媒在线把作品库、分类筛选与详情信息整理在同一条浏览路径上：先看焦点推荐，再按电影、
              电视剧、短片进入分类，最后在详情页了解导演、演员与剧情概述。所有作品资料均为示例内容，
              播放区域仅作界面演示，不接入真实视频。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/category"
                className="whitespace-nowrap rounded-md bg-primary-800 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
              >
                开始浏览作品
              </Link>
              <Link
                to="/about"
                className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-800"
              >
                了解站点说明
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 lg:col-span-5">
            {[
              { value: movies.length, label: '示例影视作品', suffix: '部' },
              { value: 3, label: '内容分类', suffix: '类' },
              { value: 9, label: '题材类型', suffix: '种' },
              { value: 3, label: '每日更新演示', suffix: '部' },
            ].map((item) => (
              <div
                key={item.label}
                className="rounded-lg border border-background-200 bg-background-100 p-4"
              >
                <p className="font-label text-3xl leading-none text-primary-800">
                  {item.value}
                  <span className="ml-1 text-sm text-foreground-500">{item.suffix}</span>
                </p>
                <p className="mt-2 text-[11px] text-foreground-500">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  )
}